// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
//   Grid,
//   Avatar,
//   Switch,
//   ToggleButtonGroup,
//   ToggleButton,
//   IconButton,
//   Select,
//   MenuItem,
// } from '@mui/material';
// import { useMain } from '../hooks/useMain';
// import CheckboxInputs from 'src/components/inputs/CheckboxInputs';
// import TextInputs from 'src/components/inputs/TextInputs';
// import RadioInputs from 'src/components/inputs/RadioInputs';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import CustomShowLoader from 'src/components/CustomComponents/CustomShowLoader';
// import TimeSlotSelector from 'src/components/inputs/TimeSlotSelector';
// import { MdDelete } from 'react-icons/md';
// import { FaRegEdit } from 'react-icons/fa';
// import { useDispatch, useSelector } from 'react-redux';
// import { setLoading, updateStaffData, resetStaffData } from 'src/redux/slices/staffSlice';

// const incentive_types = ['%', 'INR'];

// const  incentive_periods = ["daily", "weekly", "monthly"]

// const FieldData = ({ data, getData }) => {
//   const dispatch = useDispatch();
//   const [openDialogue, setOpenDialogue] = useState(false);
//   const [openConfirmDialogue, setOpenConfirmDialogue] = useState(false);
//   const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
//   const [accountStatus, setAccountStatus] = useState(null);
//   const [isAllChecked, setIsAllChecked] = useState(false);
//   const [checkedStaffs, setCheckedStaffs] = useState([]);
//   const [selectedItemId, setSelectedItemId] = useState(null);
//   const [displayImg, setDisplayImg] = useState('');
//   const [image, setImage] = useState('');

//   const { initialStaffData, loading } = useSelector((state) => state.staffs);
//   const { deleteStaff, updateStaff, setShowMessage, activeBranchId, changeStaffAccountStatus } =
//     useMain();

//   // Original checkbox handlers
//   const handleAllCheckboxChange = () => {
//     if (isAllChecked) {
//       setCheckedStaffs([]);
//     } else {
//       setCheckedStaffs(data);
//     }
//     setIsAllChecked(!isAllChecked);
//   };

//   const handleSignleCheckboxChange = (staffId) => {
//     if (checkedStaffs.some((check) => check._id === staffId)) {
//       setCheckedStaffs((prev) => prev.filter((check) => check._id !== staffId));
//     } else {
//       const checked = data.filter((item) => item._id === staffId);
//       setCheckedStaffs((prev) => [...prev, ...checked]);
//     }
//   };

//   // Redux-connected input handlers
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     dispatch(updateStaffData({ [name]: value }));
//   };

//   const handleWorkingHrsInputChange = (e) => {
//     const { name, value } = e.target;
//     dispatch(
//       updateStaffData({
//         workingHrs: { ...initialStaffData.workingHrs, [name]: value },
//       }),
//     );
//   };

//   const handleEmergencyDetailsInputChange = (e) => {
//     const { name, value } = e.target;
//     dispatch(
//       updateStaffData({
//         emergencyDetails: { ...initialStaffData.emergencyDetails, [name]: value },
//       }),
//     );
//   };

//   // Original image handler
//   const handleDisplayImageChange = (e) => {
//     const file = e.target.files[0];
//     setImage(file);
//     const reader = new FileReader();
//     reader.onload = () => {
//       if (reader.readyState === 2) {
//         setDisplayImg(reader.result);
//       }
//     };
//     reader.readAsDataURL(file);
//   };

//   // Status dialog handlers
//   const handleOpenStatusDialogue = (currentStatus, staffId) => {
//     setSelectedItemId(staffId);
//     setAccountStatus(currentStatus);
//     setOpenConfirmDialogue(true);
//   };

//   const handleCloseStatusDialogue = () => {
//     setOpenConfirmDialogue(false);
//     setSelectedItemId(null);
//     setAccountStatus(null);
//   };

//   const handleConfirmStatus = async () => {
//     try {
//       dispatch(setLoading(true));
//       const res = await changeStaffAccountStatus(selectedItemId, `?branchId=${activeBranchId}`, {
//         activeStatus: !accountStatus,
//       });

//       if (res.statusCode === 200) {
//         setShowMessage({
//           message: res.message || 'Account status changed',
//           messageType: 'success',
//         });
//         getData();
//       }
//     } catch (error) {
//       setShowMessage({ message: error.message, messageType: 'error' });
//     } finally {
//       dispatch(setLoading(false));
//       handleCloseStatusDialogue();
//     }
//   };

//   // Update staff handlers
//   const handleUpdate = (item) => {
//     console.log(item,'item')
//     setSelectedItemId(item._id);
//     setDisplayImg(item?.displayImg);
//     dispatch(
//       updateStaffData({
//         ...initialStaffData,
//         name: item?.name || "",
//         phone: item?.phone || "",
//         address: item?.address || "",
//         mail: item?.mail || "",
//         department: item?.department || "",
//         salary: item?.salary || "",
//         userType: item?.userType || "",
//         emergencyDetails: item?.emergencyDetails,
//         workingHrs: item?.workingHrs,
//         dateOfJoining: item?.dateOfJoining || "",
//         dob: item?.dob || "",
//         incentive: item?.incentive || "",
//         incentiveType: item?.incentiveType || "",
//         incentivePeriod:item?.incentivePeriod || "",
//         // targetAmount: item?.targetAmount,
//         target: item?.target || "",
//         gender: item?.gender || "",
//       }),
//     );
//     setOpenDialogue(true);
//   };

//   const handleCloseDialogue = () => {
//     setOpenDialogue(false);
//     dispatch(resetStaffData());
//   };

//   const handleUpdateStaffData = async () => {
//     try {
//       dispatch(setLoading(true));
//       const res = await updateStaff(
//         selectedItemId,
//         initialStaffData,
//         `?branchId=${activeBranchId}`,
//       );
//       if (res?.statusCode === 200) {
//         setShowMessage({
//           message: res.message || 'Staff updated successfully',
//           messageType: 'success',
//         });
//         getData();
//       } else {
//         setShowMessage({
//           message: res.message || 'Staff details not updated',
//           messageType: 'error',
//         });

//       }
//     } catch (error) {
//       setShowMessage({ message: error.message, messageType: 'error' });
//     } finally {
//       dispatch(setLoading(false));
//       handleCloseDialogue();
//     }
//   };

//   // Delete handlers
//   const handleDeleteField = (id) => {
//     setSelectedItemId(id);
//     setOpenDeleteDialog(true);
//   };

//   const confirmDelete = async () => {
//     dispatch(setLoading(true));
//     try {
//       const res = await deleteStaff(selectedItemId, `?branchId=${activeBranchId}`);
//       if (res?.statusCode === 200) {
//         setShowMessage({ message: 'Staff deleted successfully', messageType: 'success' });
//         await getData();
//       }
//     } catch (error) {
//       setShowMessage({ message: error.message, messageType: 'error' });
//     } finally {
//       dispatch(setLoading(false));
//       setOpenDeleteDialog(false);
//     }
//   };

//   useEffect(() => {
//     setIsAllChecked(checkedStaffs.length === data.length);
//   }, [checkedStaffs, data]);

//   console.log(initialStaffData,'initialStaffData')

//   return (
//     <Box sx={{ overflow: 'auto', width: { xs: '450px', sm: 'auto' } }}>
//       {/* Original Table Structure */}
//       <table className="table-container mt-3">
//         <thead className="table-thead">
//           <tr>
//             <th>
//               <CheckboxInputs
//                 type={'Heading'}
//                 isAllChecked={isAllChecked}
//                 handleAllCheckboxChange={handleAllCheckboxChange}
//               />
//             </th>
//             {[
//               'Name',
//               'Contact Number',
//               'Gender',
//               'Email',
//               'Salary',
//               'Address',
//               'Join Date',
//               'Department',
//               'Active',
//               'Actions',
//             ].map((h, index) => (
//               <th key={index} style={{ width: '100%' }}>
//                 {h}
//               </th>
//             ))}
//           </tr>
//         </thead>
//         <tbody className="table-tbody">
//           {data.map((item) => {
//             const originalDate = item?.dateOfJoining;
//             let formattedJoinDate = '';
//             if (originalDate) {
//               const [year, month, day] = originalDate.split('-');
//               formattedJoinDate = `${day}-${month}-${year}`;
//             }
//             return (
//               <tr key={item._id}>
//                 <td style={{ width: '20%' }}>
//                   <CheckboxInputs
//                     type={'content'}
//                     handleSignleCheckboxChange={handleSignleCheckboxChange}
//                     checkedItems={checkedStaffs}
//                     fieldId={item?._id}
//                   />
//                 </td>
//                 <td>{item?.name}</td>
//                 <td>{item?.phone}</td>
//                 <td>{item?.gender}</td>
//                 <td>{item?.mail}</td>
//                 <td>{item?.salary}</td>
//                 <td>{item?.address}</td>
//                 <td>{formattedJoinDate}</td>
//                 <td>{item?.department}</td>
//                 <td>
//                   <Switch
//                     checked={item?.active}
//                     onClick={() => handleOpenStatusDialogue(item?.active, item._id)}
//                   />
//                 </td>
//                 <td style={{ width: '100%', marginLeft: '-1rem' }}>
//                   <IconButton
//                     onClick={() => handleUpdate(item)}
//                     color="secondary"
//                     title="Update"
//                     style={{ margin: '-2px' }}
//                   >
//                     <FaRegEdit style={{ color: '#696969', fontSize: '1rem' }} />
//                   </IconButton>
//                   <IconButton
//                     onClick={() => handleDeleteField(item._id)}
//                     color="error"
//                     title="Delete"
//                     style={{ margin: '-6px' }}
//                   >
//                     <MdDelete color="#FF4D4D" style={{ fontSize: '1.2rem', marginTop: '1px' }} />
//                   </IconButton>
//                 </td>
//               </tr>
//             );
//           })}
//         </tbody>
//       </table>

//       {/* Original Update Dialog */}
//       <Dialog open={openDialogue} onClose={handleCloseDialogue} maxWidth="xl">
//         <DialogTitle>Staff Details</DialogTitle>
//         <DialogContent style={{ width: '1300px' }}>
//           <DialogContentText>Here you can update Staff details.</DialogContentText>
//           <Box style={{ marginTop: '20px' }}>
//             <Grid container spacing={3}>
//               <Grid item xs={6} md={4}>
//                 <TextInputs
//                   title={'Name'}
//                   name={'name'}
//                   value={initialStaffData?.name || ''}
//                   handleChange={handleInputChange}
//                   type={'text'}
//                   required={false}
//                 />
//               </Grid>
//               <Grid item xs={6} md={4}>
//                 <TextInputs
//                   title={'Date of Birth'}
//                   name={'dob'}
//                   value={initialStaffData?.dob || ''}
//                   handleChange={handleInputChange}
//                   type={'date'}
//                   style={{ backgroundColor: '#f4f4f4', color: '#777', cursor: 'not-allowed' }}
//                   required={false}
//                 />
//               </Grid>
//               <Grid item xs={6} md={4}>
//                 <TextInputs
//                   title={'Contact Number'}
//                   name={'phone'}
//                   value={initialStaffData?.phone || ''}
//                   handleChange={handleInputChange}
//                   type={'number'}
//                   required={false}
//                 />
//               </Grid>
//             </Grid>
//           </Box>

//           <Box style={{ marginTop: '20px' }}>
//             <Grid container spacing={3}>
//               <Grid item xs={6} md={4}>
//                 <TextInputs
//                   title={'Email Address'}
//                   name={'mail'}
//                   value={initialStaffData?.mail || ''}
//                   handleChange={handleInputChange}
//                   type={'email'}
//                   required={false}
//                 />
//               </Grid>
//               <Grid item xs={6} md={4}>
//                 <Box>
//                   <Grid container spacing={3}>
//                     <Grid item xs={6}>
//                       <TimeSlotSelector
//                         required={false}
//                         title={'Shift Timing'}
//                         name={'start'}
//                         value={initialStaffData?.workingHrs?.start || ''}
//                         handleChange={handleWorkingHrsInputChange}
//                       />
//                     </Grid>
//                     <Grid item xs={6} style={{ marginTop: '26px' }}>
//                       <TimeSlotSelector
//                         required={false}
//                         title={'  '}
//                         name={'end'}
//                         value={initialStaffData?.workingHrs?.end || ''}
//                         handleChange={handleWorkingHrsInputChange}
//                       />
//                     </Grid>
//                   </Grid>
//                 </Box>
//               </Grid>
//               <Grid item xs={6} md={4}>
//                 <TextInputs
//                   title={'Monthly Salary'}
//                   name={'salary'}
//                   value={initialStaffData?.salary || ''}
//                   handleChange={handleInputChange}
//                   type={'number'}
//                   required={false}
//                 />
//               </Grid>
//             </Grid>
//           </Box>

//           <Box style={{ marginTop: '20px' }}>
//             <Grid container spacing={3}>
//               <Grid item xs={6} md={4}>
//                 <TextInputs
//                   title={'Emergency Contact Number'}
//                   name={'contactNo'}
//                   value={initialStaffData?.emergencyDetails?.contactNo || ''}
//                   handleChange={handleEmergencyDetailsInputChange}
//                   type={'number'}
//                   required={false}
//                 />
//               </Grid>
//               <Grid item xs={6} md={4}>
//                 <TextInputs
//                   title={'Emergency Contact Person'}
//                   name={'name'}
//                   value={initialStaffData?.emergencyDetails?.name || ''}
//                   handleChange={handleEmergencyDetailsInputChange}
//                   type={'text'}
//                   required={false}
//                 />
//               </Grid>
//               <Grid item xs={6} md={4}>
//                 <TextInputs
//                   title={'Address'}
//                   name={'address'}
//                   value={initialStaffData?.address || ''}
//                   handleChange={handleInputChange}
//                   type={'text'}
//                   required={false}
//                 />
//               </Grid>
//             </Grid>
//           </Box>

//           <Box style={{ marginTop: '20px' }}>
//             <Grid container spacing={3}>
//               <Grid item xs={6} md={4}>
//                 <RadioInputs
//                   title={'Gender'}
//                   name={'gender'}
//                   value={initialStaffData?.gender || ''}
//                   handleChange={handleInputChange}
//                   options={[
//                     { title: 'M', value: 'Male' },
//                     { title: 'F', value: 'Female' },
//                   ]}
//                   required={false}
//                 />
//               </Grid>
//               <Grid item xs={6} md={4}>
//                 <TextInputs
//                   title={'User Type'}
//                   name={'userType'}
//                   value={initialStaffData?.userType || ''}
//                   handleChange={handleInputChange}
//                   type={'text'}
//                   required={false}
//                 />
//               </Grid>
//               <Grid item xs={6} md={4}>
//                 <TextInputs
//                   title={'Department'}
//                   name={'department'}
//                   value={initialStaffData?.department || ''}
//                   handleChange={handleInputChange}
//                   type={'text'}
//                   required={false}
//                 />
//               </Grid>
//             </Grid>
//           </Box>
//           <Box style={{ marginTop: '20px' }}>
//             <Grid container spacing={3}>
//               <Grid item xs={12} md={4}>
//                 <div style={{ marginBottom: '5px', fontWeight: 'bold', color: 'black' }}>
//                   Incentive Period
//                 </div>
//                 <Select
//                   name="incentivePeriod"
//                   value={initialStaffData?.incentivePeriod}
//                   onChange={handleInputChange}
//                   fullWidth
//                   sx={{ height: '50px' }}
//                 >
//                   {incentive_periods.map((period) => (
//                     <MenuItem key={period} value={period}>
//                       {period.charAt(0).toUpperCase() + period.slice(1)}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </Grid>

//               <Grid item xs={12} md={4}>
//                 <TextInputs
//                   required={false}
//                   title={'Incentive'}
//                   name={'incentive'}
//                   value={initialStaffData?.incentive || 0}
//                   handleChange={handleInputChange}
//                   type={'number'}
//                   placeholder={'0'}
//                 />
//               </Grid>

//               <Grid item xs={12} md={4}>
//                 <div style={{ marginBottom: '6px', fontWeight: 'bold', color: 'black' }}>
//                   Incentive Type
//                 </div>
//                 <ToggleButtonGroup
//                   value={initialStaffData?.incentiveType || ''}
//                   exclusive
//                   onChange={(e, newValue) => dispatch(updateStaffData({ incentiveType: newValue }))}
//                   fullWidth
//                   sx={{
//                     borderRadius: '4px',
//                     height: '50px',
//                     backgroundColor: '#f0f0f0',
//                   }}
//                 >
//                   {incentive_types.map((type) => (
//                     <ToggleButton
//                       key={type}
//                       value={type}
//                       aria-label={type}
//                       sx={{
//                         color: '#000',
//                         backgroundColor: '#e0e0e0',
//                         height: '3.4rem',
//                         '&.Mui-selected': {
//                           backgroundColor: '#6174DD',
//                           color: '#fff',
//                           '&:hover': { backgroundColor: '#6174DD' },
//                         },
//                         '&:not(.Mui-selected)': {
//                           '&:hover': { backgroundColor: '#d0d0d0' },
//                         },
//                       }}
//                     >
//                       {type}
//                     </ToggleButton>
//                   ))}
//                 </ToggleButtonGroup>
//               </Grid>
//               <Grid item xs={12} md={4}>
//                 <TextInputs
//                   required={false}
//                   title={'Target Amount'}
//                   name={'target'}
//                   value={initialStaffData?.target || 0}
//                   handleChange={handleInputChange}
//                   type={'number'}
//                   placeholder={'0'}
//                 />
//               </Grid>
//             </Grid>
//           </Box>
//           <Box style={{ marginTop: '20px' }}>
//             <Grid container spacing={3}>
//               <Grid item xs={6} md={4}>
//                 <TextInputs
//                   title={'Date of Joining'}
//                   name={'dateOfJoining'}
//                   value={initialStaffData?.dateOfJoining || ''}
//                   handleChange={handleInputChange}
//                   type={'date'}
//                   max={new Date().toISOString().split('T')[0]}
//                   style={{ backgroundColor: '#f4f4f4', color: '#777', cursor: 'not-allowed' }}
//                   required={false}
//                 />
//               </Grid>
//               <Grid item xs={6} md={8} sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//                 <Avatar
//                   src={displayImg}
//                   alt={'image'}
//                   sx={{ width: 35, height: 35, alignSelf: 'center' }}
//                 />
//                 <TextInputs
//                   title={'Update Photo'}
//                   name={'displayImg'}
//                   handleChange={handleDisplayImageChange}
//                   type={'file'}
//                   required={false}
//                 />
//                 <Button
//                   variant="contained"
//                   sx={{ backgroundColor: 'primary', color: '#fff' }}
//                   onClick={() => console.log('Update image logic')}
//                 >
//                   Update image
//                 </Button>
//               </Grid>
//             </Grid>
//           </Box>
//         </DialogContent>
//         <DialogActions>
//           {loading ? (
//             <ShowLoader />
//           ) : (
//             <>
//               <div style={{ width: '200px', margin: '3rem auto' }}>
//                 <Button
//                   variant="contained"
//                   fullWidth
//                   color="primary"
//                   onClick={handleCloseDialogue}
//                   sx={{ background: '#6174DD' }}
//                 >
//                   Cancel
//                 </Button>
//               </div>
//               <div style={{ width: '200px', margin: '3rem auto' }}>
//                 <Button
//                   variant="contained"
//                   fullWidth
//                   color="primary"
//                   onClick={handleUpdateStaffData}
//                   sx={{ background: '#6174DD' }}
//                 >
//                   Update
//                 </Button>
//               </div>
//             </>
//           )}
//         </DialogActions>
//       </Dialog>

//       {/* Status Confirmation Dialog */}
//       <Dialog open={openConfirmDialogue} onClose={handleCloseStatusDialogue}>
//         <DialogContent>
//           Are you sure you want to {accountStatus ? 'deactivate' : 'activate'} this account?
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseStatusDialogue}>Cancel</Button>
//           <Button onClick={handleConfirmStatus} color="primary">
//             Confirm
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Delete Dialog */}
//       <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
//         <DialogContent>Are you sure you want to delete this staff?</DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenDeleteDialog(false)}>Cancel</Button>
//           <Button onClick={confirmDelete} color="error">
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default FieldData;

import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Grid,
  Avatar,
  Switch,
  ToggleButtonGroup,
  ToggleButton,
  IconButton,
  Select,
  MenuItem,
  Card,
  CardContent,
  Typography,
  FormControlLabel,
  Tooltip 
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useMain } from '../hooks/useMain';
import CheckboxInputs from 'src/components/inputs/CheckboxInputs';
import TextInputs from 'src/components/inputs/TextInputs';
import RadioInputs from 'src/components/inputs/RadioInputs';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import TimeSlotSelector from 'src/components/inputs/TimeSlotSelector';
import { MdDelete } from 'react-icons/md';
import { FaRegEdit } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading, updateStaffData, resetStaffData } from 'src/redux/slices/staffSlice';
import { getHighlightedText } from 'src/utils/textUtils';

const incentive_types = ['%', 'INR'];
const incentive_periods = ["daily", "weekly", "monthly"];
const userType = ['Admin', 'receptionist', 'Artist', 'Cleaning staff']

export const TrimData = (data) => {
  if (typeof data === 'string' && data.length > 20) {
    return data.substring(0, 20) + '...';
  }
  return data;
};

const FieldData = ({ data, getData }) => {
  const dispatch = useDispatch();
  const [openDialogue, setOpenDialogue] = useState(false);
  const [openConfirmDialogue, setOpenConfirmDialogue] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [accountStatus, setAccountStatus] = useState(null);
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [checkedStaffs, setCheckedStaffs] = useState([]);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [displayImg, setDisplayImg] = useState('');
  const [image, setImage] = useState('');
  const [hoveredItemId, setHoveredItemId] = useState(null);
  const [showIncentiveErrors, setShowIncentiveErrors] = useState(false);

  const { initialStaffData, loading, filters } = useSelector((state) => state.staffs);
  const { deleteStaff, updateStaff, setShowMessage, activeBranchId, changeStaffAccountStatus } =
    useMain();

  // Calculate incentive amount
  const calculateIncentiveAmount = () => {
    if (!initialStaffData?.target || !initialStaffData?.incentive) return '0';

    const salary = parseFloat(initialStaffData.target);
    const incentive = parseFloat(initialStaffData.incentive);

    if (initialStaffData.incentiveType === '%') {
      return (salary * (incentive / 100)).toFixed(2);
    } else {
      return incentive.toFixed(2);
    }
  };

  const incentiveAmount = calculateIncentiveAmount();
  const targetValue = parseFloat(initialStaffData?.target) || 0;

  const getCalculationText = () => {
    const inc = parseFloat(initialStaffData?.incentive);
    if (!inc) return 'Enter incentive to calculate';

    if (initialStaffData?.incentiveType === '%') {
      return targetValue === 0
        ? `No target: ${inc}% of every service amount`
        : `${targetValue} × ${inc}% = ${incentiveAmount}`;
    }
    return targetValue === 0
      ? `No target: ₹${inc} credited from the first sale`
      : `₹${incentiveAmount}`;
  };

const incentiveInfoText = initialStaffData?.allowIncentive
  ? 'Incentive is ON: the staff starts earning incentive on sales once the target is crossed. If the target is 0 or empty, no target is needed and the incentive is credited from the first sale, on the full bill amount.'
  : 'Incentive is OFF: no incentive will be credited, even if target and incentive values are saved.';
  // Checkbox handlers
  const handleAllCheckboxChange = () => {
    if (isAllChecked) {
      setCheckedStaffs([]);
    } else {
      setCheckedStaffs(data);
    }
    setIsAllChecked(!isAllChecked);
  };

  const handleSignleCheckboxChange = (staffId) => {
    if (checkedStaffs.some((check) => check._id === staffId)) {
      setCheckedStaffs((prev) => prev.filter((check) => check._id !== staffId));
    } else {
      const checked = data.filter((item) => item._id === staffId);
      setCheckedStaffs((prev) => [...prev, ...checked]);
    }
  };

  // Input handlers
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    dispatch(updateStaffData({ [name]: value }));
  };
  const handleAllowIncentiveChange = (e) => {
    dispatch(updateStaffData({ allowIncentive: e.target.checked }));
  };

  // Cleans a phone value: digits only, removes +91 / 91 country code
  // Cleans a phone value: digits only, keeps the LAST 10 digits
  const cleanPhone = (raw) => {
    const digits = String(raw || '').replace(/\D/g, ''); // remove spaces, dashes, +, brackets
    return digits.length > 10 ? digits.slice(-10) : digits;
  };

  const handlePhoneChange = (e) => {
    const { name, value } = e.target;
    dispatch(updateStaffData({ [name]: cleanPhone(value) }));
  };

  const handleEmergencyContactNoChange = (e) => {
    const { value } = e.target;
    dispatch(
      updateStaffData({
        emergencyDetails: {
          ...initialStaffData.emergencyDetails,
          contactNo: cleanPhone(value),
        },
      }),
    );
  };

  const handleWorkingHrsInputChange = (e) => {
    const { name, value } = e.target;
    dispatch(
      updateStaffData({
        workingHrs: { ...initialStaffData.workingHrs, [name]: value },
      }),
    );
  };

  const handleEmergencyDetailsInputChange = (e) => {
    const { name, value } = e.target;
    dispatch(
      updateStaffData({
        emergencyDetails: { ...initialStaffData.emergencyDetails, [name]: value },
      }),
    );
  };

  // Image handler
  const handleDisplayImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.readyState === 2) {
        setDisplayImg(reader.result);
      }
    };
    reader.readAsDataURL(file);
  };

  // Status dialog handlers
  const handleOpenStatusDialogue = (currentStatus, staffId) => {
    setSelectedItemId(staffId);
    setAccountStatus(currentStatus);
    setOpenConfirmDialogue(true);
  };

  const handleCloseStatusDialogue = () => {
    setOpenConfirmDialogue(false);
    setSelectedItemId(null);
    setAccountStatus(null);
  };

  const handleConfirmStatus = async () => {
    try {
      dispatch(setLoading(true));
      const res = await changeStaffAccountStatus(selectedItemId, `?branchId=${activeBranchId}`, {
        activeStatus: !accountStatus,
      });

      if (res.statusCode === 200) {
        setShowMessage({
          message: res.message || 'Account status changed',
          messageType: 'success',
        });
        getData();
      }
    } catch (error) {
      setShowMessage({ message: error.message, messageType: 'error' });
    } finally {
      dispatch(setLoading(false));
      handleCloseStatusDialogue();
    }
  };

  // Update staff handlers
  const handleUpdate = (item) => {
    setSelectedItemId(item._id);
    setDisplayImg(item?.displayImg);
    dispatch(
      updateStaffData({
        ...initialStaffData,
        name: item?.name || "",
        phone: item?.phone || "",
        address: item?.address || "",
        mail: item?.mail || "",
        department: item?.department || "",
        salary: item?.salary ?? "",
        userType: item?.userType || "",
        emergencyDetails: item?.emergencyDetails,
        workingHrs: item?.workingHrs,
        dateOfJoining: item?.dateOfJoining || "",
        dob: item?.dob || "",
        incentive: item?.incentive || "",
        incentiveType: item?.incentiveType || "",
        incentivePeriod: item?.incentivePeriod || "",
        allowIncentive: item?.allowIncentive || false,   
        target: item?.target || "",
        gender: item?.gender || "",
      }),
    );
    setOpenDialogue(true);
  };

  const handleCloseDialogue = () => {
    setOpenDialogue(false);
    setShowIncentiveErrors(false);
    dispatch(resetStaffData());
  };

  const handleUpdateStaffData = async () => {
        if (
      initialStaffData?.allowIncentive &&
      (!(Number(initialStaffData?.incentive) > 0) ||
        !initialStaffData?.incentiveType ||
        !initialStaffData?.incentivePeriod)
    ) {
      setShowIncentiveErrors(true);
      setShowMessage({
        message: 'Please fill Incentive, Incentive Type and Incentive Period.',
        messageType: 'error',
      });
      return;
    }
    // setShowIncentiveErrors(false);
    // try {
    //   dispatch(setLoading(true));
    //   const res = await updateStaff(
    //     selectedItemId,
    //     initialStaffData,
    //     `?branchId=${activeBranchId}`,
    //   );
        setShowIncentiveErrors(false);
    try {
      dispatch(setLoading(true));

      // If salary is empty, send 0
            const payload = {
              ...initialStaffData,
              phone: cleanPhone(initialStaffData?.phone),
              emergencyDetails: {
                ...initialStaffData?.emergencyDetails,
                contactNo: cleanPhone(initialStaffData?.emergencyDetails?.contactNo),
              },
              salary: initialStaffData?.salary === '' || initialStaffData?.salary == null
                ? "0"
                : initialStaffData.salary,
            };

      const res = await updateStaff(
        selectedItemId,
        payload,
        `?branchId=${activeBranchId}`,
      );
      if (res?.statusCode === 200) {
        setShowMessage({
          message: res.message || 'Staff updated successfully',
          messageType: 'success',
        });
        getData();
      } else {
        setShowMessage({
          message: res.message || 'Staff details not updated',
          messageType: 'error',
        });
      }
    } catch (error) {
      setShowMessage({ message: error.message, messageType: 'error' });
    } finally {
      dispatch(setLoading(false));
      handleCloseDialogue();
    }
  };

  // Delete handlers
  const handleDeleteField = (id) => {
    setSelectedItemId(id);
    setOpenDeleteDialog(true);
  };

  const confirmDelete = async () => {
    dispatch(setLoading(true));
    try {
      const res = await deleteStaff(selectedItemId, `?branchId=${activeBranchId}`);
      if (res?.statusCode === 200) {
        setShowMessage({ message: 'Staff deleted successfully', messageType: 'success' });
        await getData();
      }
    } catch (error) {
      setShowMessage({ message: error.message, messageType: 'error' });
    } finally {
      dispatch(setLoading(false));
      setOpenDeleteDialog(false);
    }
  };

  useEffect(() => {
    setIsAllChecked(checkedStaffs.length === data.length);
  }, [checkedStaffs, data]);
// Grid layout for the staff table (overrides flex-based .table-thead/.table-tbody CSS)
  const staffGridTemplate = '30px 1fr 120px 90px 1fr 100px 130px 80px 100px';

  const staffGridRowStyle = {
    display: 'grid',
    gridTemplateColumns: staffGridTemplate,
    alignItems: 'center',
    columnGap: '10px',
  };
  return (
    <>
      <Box sx={{ overflow: 'auto', width: { xs: '450px', sm: 'auto' } }}>
        {/* Table Structure */}
        <table className="table-container mt-3" style={{ width: '100%' }}>
          <thead className="table-thead">
            <tr style={staffGridRowStyle}>
              <th>
                <CheckboxInputs
                  type={'Heading'}
                  isAllChecked={isAllChecked}
                  handleAllCheckboxChange={handleAllCheckboxChange}
                />
              </th>
              {[
                'Name',
                'Contact Number',
                'Gender',
                'Email',
                'Salary',
                'Department',
                'Active',
                'Actions',
              ].map((h, index) => (
                <th key={index} style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="table-tbody">
            {data.map((item) => {
              const originalDate = item?.dateOfJoining;
              let formattedJoinDate = '';
              if (originalDate) {
                const [year, month, day] = originalDate.split('-');
                formattedJoinDate = `${day}-${month}-${year}`;
              }
             return (
                <tr key={item._id} style={staffGridRowStyle}>
                  <td>
                    <CheckboxInputs
                      type={'content'}
                      handleSignleCheckboxChange={handleSignleCheckboxChange}
                      checkedItems={checkedStaffs}
                      fieldId={item?._id}
                    />
                  </td>
                  <td style={{ position: "relative" ,textAlign: 'center',}}>
                    <div
                      onMouseEnter={() => setHoveredItemId(item._id + "_name")}
                      onMouseLeave={() => setHoveredItemId(null)}
                      style={{ cursor: "pointer" }}
                    >
                      {getHighlightedText(TrimData(item?.name), filters?.search)}

                      {hoveredItemId === item._id + "_name" && (
                        <div
                          style={{
                            position: "absolute",
                            top: "100%",
                            left: 0,
                            backgroundColor: "#dfe3f8",
                            border: "1px solid #ccc",
                            padding: "8px",
                            borderRadius: "5px",
                            zIndex: 5,
                            boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                            whiteSpace: "pre-wrap",
                            maxWidth: "300px",
                          }}
                        >
                          {getHighlightedText(item?.name, filters?.search)}
                        </div>
                      )}
                    </div>
                  </td>
                  <td  style={{ position: "relative" ,textAlign: 'center',}}>{item?.phone}</td>
                  <td style={{ textAlign: 'center' }}>{item?.gender}</td>
                  <td style={{ position: "relative" , textAlign: 'center'}}>
                    <div
                      onMouseEnter={() => setHoveredItemId(item._id + "_mail")}
                      onMouseLeave={() => setHoveredItemId(null)}
                      style={{ cursor: "pointer" }}
                    >
                      {TrimData(item?.mail)}

                      {hoveredItemId === item._id + "_mail" && (
                        <div
                          style={{
                            position: "absolute",
                            top: "100%",
                            left: 0,
                            backgroundColor: "#dfe3f8",
                            border: "1px solid #ccc",
                            padding: "8px",
                            borderRadius: "5px",
                            zIndex: 5,
                            boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                            whiteSpace: "pre-wrap",
                            maxWidth: "300px",
                          }}
                        >
                          {item?.mail}
                        </div>
                      )}
                    </div>
                  </td>
                  <td style={{ textAlign: 'center' }}>{item?.salary}</td>
                  {/* <td style={{ width: '100%' }}>{item?.address}</td>
                <td>{formattedJoinDate}</td> */}
                  <td style={{ textAlign: 'center' }}>{item?.department}</td>
                  <td style={{ textAlign: 'center' }}>
                    <Switch
                      checked={item?.active}
                      onClick={() => handleOpenStatusDialogue(item?.active, item._id)}
                    />
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <IconButton
                      onClick={() => handleUpdate(item)}
                      color="secondary"
                      title="Update"
                      style={{ margin: '-2px' }}
                    >
                      <FaRegEdit style={{ color: '#696969', fontSize: '1rem' }} />
                    </IconButton>
                    <IconButton
                      onClick={() => handleDeleteField(item._id)}
                      color="error"
                      title="Delete"
                      style={{ margin: '-6px' }}
                    >
                      <MdDelete color="#FF4D4D" style={{ fontSize: '1.2rem', marginTop: '1px' }} />
                    </IconButton>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {/* Updated Dialog with Smaller Size */}
        <Dialog open={openDialogue} onClose={handleCloseDialogue} maxWidth="md" fullWidth>
          <DialogTitle sx={{ pb: 1, fontSize: '1.1rem' }}>Update Staff Details</DialogTitle>
          <DialogContent sx={{ maxHeight: '70vh', overflow: 'auto' }}>
            <DialogContentText sx={{ mb: 2, fontSize: '0.9rem' }}>
              Update the staff information below.
            </DialogContentText>

            {/* Section 1: Staff Details */}
            <Card sx={{ mb: 1.5, border: '1px solid #e0e0e0' }}>
              <CardContent sx={{ pb: 1, '&:last-child': { pb: 1 } }}>
                <Typography variant="subtitle1" sx={{ mb: 1.5, color: '#6174DD', fontWeight: 'bold' }}>
                  Staff Details
                </Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={12} md={6}>
                    <TextInputs
                      title={'Name'}
                      name={'name'}
                      value={initialStaffData?.name || ''}
                      handleChange={handleInputChange}
                      type={'text'}
                      required={false}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextInputs
                      title={'Phone Number'}
                      name={'phone'}
                      value={initialStaffData?.phone || ''}
                      handleChange={handlePhoneChange}
                      type={'text'}
                      required={false}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextInputs
                      title={'Email Address'}
                      name={'mail'}
                      value={initialStaffData?.mail || ''}
                      handleChange={handleInputChange}
                      type={'email'}
                      required={false}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <RadioInputs
                      title={'Gender'}
                      name={'gender'}
                      value={initialStaffData?.gender || ''}
                      handleChange={handleInputChange}
                      options={[
                        { title: 'M', value: 'Male' },
                        { title: 'F', value: 'Female' },
                      ]}
                      required={false}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextInputs
                      title={'Date of Birth'}
                      name={'dob'}
                      value={initialStaffData?.dob || ''}
                      handleChange={handleInputChange}
                      type={'date'}
                      required={false}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextInputs
                      title={'Address'}
                      name={'address'}
                      value={initialStaffData?.address || ''}
                      handleChange={handleInputChange}
                      type={'text'}
                      required={false}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>

            {/* Section 2: Employment Details */}
            <Card sx={{ mb: 1.5, border: '1px solid #e0e0e0' }}>
              <CardContent sx={{ pb: 1, '&:last-child': { pb: 1 } }}>
                <Typography variant="subtitle1" sx={{ mb: 1.5, color: '#6174DD', fontWeight: 'bold' }}>
                  Employment Details
                </Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={12} md={6}>
                    <TextInputs
                      title={'Date of Joining'}
                      name={'dateOfJoining'}
                      value={initialStaffData?.dateOfJoining || ''}
                      handleChange={handleInputChange}
                      type={'date'}
                      max={new Date().toISOString().split('T')[0]}
                      required={false}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Box>
                      <Grid container spacing={1}>
                        <Grid item xs={6}>
                          <TimeSlotSelector
                            required={false}
                            title={'Shift Start'}
                            name={'start'}
                            value={initialStaffData?.workingHrs?.start || ''}
                            handleChange={handleWorkingHrsInputChange}
                            size="small"
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TimeSlotSelector
                            required={false}
                            title={'Shift End'}
                            name={'end'}
                            value={initialStaffData?.workingHrs?.end || ''}
                            handleChange={handleWorkingHrsInputChange}
                            size="small"
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                  {/* <Grid item xs={12} md={6}>
                  <TextInputs
                    title={'User Type'}
                    name={'userType'}
                    value={initialStaffData?.userType || ''}
                    handleChange={handleInputChange}
                    type={'text'}
                    required={false}
                    size="small"
                  />
                </Grid> */}
                  <Grid item xs={12} md={4}>
                    <div style={{ marginBottom: '5px', fontWeight: 'bold', color: 'black' }}>
                      User Type
                    </div>
                    <Select
                      name="userType"
                      value={initialStaffData?.userType || ''}
                      onChange={handleInputChange}
                      fullWidth
                      sx={{ height: '50px' }}
                    >
                      {userType.map((type) => (
                        <MenuItem key={type} value={type}>
                          {type}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextInputs
                      title={'Department'}
                      name={'department'}
                      value={initialStaffData?.department || ''}
                      handleChange={handleInputChange}
                      type={'text'}
                      required={false}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextInputs
                      title={'Emergency Contact Person'}
                      name={'name'}
                      value={initialStaffData?.emergencyDetails?.name || ''}
                      handleChange={handleEmergencyDetailsInputChange}
                      type={'text'}
                      required={false}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextInputs
                      title={'Emergency Contact Number'}
                      name={'contactNo'}
                      value={initialStaffData?.emergencyDetails?.contactNo || ''}
                      handleChange={handleEmergencyContactNoChange}
                      type={'text'}
                      required={false}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mt: 1 }}>
                      <Avatar
                        src={displayImg}
                        alt={'Staff Photo'}
                        sx={{ width: 40, height: 40 }}
                      />
                      <Box sx={{ flexGrow: 1 }}>
                        <TextInputs
                          title={'Update Photo'}
                          name={'displayImg'}
                          handleChange={handleDisplayImageChange}
                          type={'file'}
                          required={false}
                          size="small"
                        />
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>

            {/* Section 3: Salary Details */}
            <Card sx={{ mb: 1.5, border: '1px solid #e0e0e0' }}>
              <CardContent sx={{ pb: 1, '&:last-child': { pb: 1 } }}>
                <Typography variant="subtitle1" sx={{ mb: 1.5, color: '#6174DD', fontWeight: 'bold' }}>
                  Salary Details
                </Typography>
                      <Grid container spacing={1.5}>
                                {/* ROW 1: always visible */}
                                <Grid item xs={12} md={4}>
                                  <TextInputs
                                    title={'Monthly Salary'}
                                    name={'salary'}
                                    value={initialStaffData?.salary ?? ''}
                                    handleChange={handleInputChange}
                                    type={'number'}
                                    required={false}
                                    size="small"
                                  />
                                </Grid>

                                <Grid item xs={12} md={4}>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 'bold',
              mb: 0.5,
              color: 'black',
              fontSize: '0.875rem',
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
            }}
          >
            Allow Incentive
            <Tooltip title={incentiveInfoText} arrow placement="top">
              <InfoOutlinedIcon sx={{ fontSize: 15, color: '#9aa0a6', cursor: 'pointer' }} />
            </Tooltip>
          </Typography>
          <FormControlLabel
            control={
              <Switch
                checked={!!initialStaffData?.allowIncentive}
                onChange={handleAllowIncentiveChange}
                color="primary"
              />
            }
            label={initialStaffData?.allowIncentive ? 'ON' : 'OFF'}
          />
        </Grid>
                        {/* Only when toggle is ON */}
                        {initialStaffData?.allowIncentive && (
                          <>
                            {/* Line break */}
                            <Grid item xs={12} sx={{ py: '0 !important' }} />

                            {/* ROW 2: Target, Incentive, Incentive Period */}
                            <Grid item xs={12} md={4}>
                              <TextInputs
                                title={'Target Amount (optional, empty = 0)'}
                                name={'target'}
                                value={initialStaffData?.target || ''}
                                handleChange={handleInputChange}
                                type={'number'}
                                required={false}
                                size="small"
                              />
                            </Grid>

                            <Grid item xs={12} md={4}>
                              <TextInputs
                                  title={'Incentive'}
                                  name={'incentive'}
                                  value={initialStaffData?.incentive || ''}
                                  handleChange={handleInputChange}
                                  type={'number'}
                                  size="small"
                                  fieldValidation={showIncentiveErrors && !(Number(initialStaffData?.incentive) > 0)}
                                />
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <div style={{ marginBottom: '6px', fontWeight: 'bold', color: 'black' }}>
                                        Incentive Period <span style={{ color: 'red' }}>*</span>
                                      </div>
                                      <Select
                                        name="incentivePeriod"
                                        value={initialStaffData?.incentivePeriod || ''}
                                        onChange={handleInputChange}
                                        fullWidth
                                        error={showIncentiveErrors && !initialStaffData?.incentivePeriod}
                                        sx={{ height: '55px' }}
                                      >
                                  {incentive_periods.map((period) => (
                                    <MenuItem key={period} value={period}>
                                      {period.charAt(0).toUpperCase() + period.slice(1)}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </Grid>

                            {/* ROW 3: Incentive Type, Incentive Calculation */}
                            <Grid item xs={12} md={4}>
                              <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.5, color: 'black', fontSize: '0.875rem' }}>
                                Incentive Type
                              </Typography>
                              <ToggleButtonGroup
                                value={initialStaffData?.incentiveType || ''}
                                exclusive
                                onChange={(e, newValue) => {
                                  if (newValue !== null) dispatch(updateStaffData({ incentiveType: newValue }));
                                }}
                                fullWidth
                                sx={{ borderRadius: '4px', height: '40px', backgroundColor: '#f0f0f0' }}
                              >
                                {incentive_types.map((type) => (
                                  <ToggleButton
                                    key={type}
                                    value={type}
                                    aria-label={type}
                                    sx={{
                                      color: '#000',
                                      backgroundColor: '#e0e0e0',
                                      height: '2.5rem',
                                      fontSize: '0.875rem',
                                      '&.Mui-selected': {
                                        backgroundColor: '#6174DD',
                                        color: '#fff',
                                        '&:hover': { backgroundColor: '#6174DD' },
                                      },
                                      '&:not(.Mui-selected)': {
                                        '&:hover': { backgroundColor: '#d0d0d0' },
                                      },
                                    }}
                                  >
                                    {type}
                                  </ToggleButton>
                                ))}
                              </ToggleButtonGroup>
                            </Grid>

                            <Grid item xs={12} md={8}>
                              <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.5, color: 'black', fontSize: '0.875rem' }}>
                                Incentive Calculation
                              </Typography>
                              <Box
                                      sx={{
                                        height: '40px',
                                        px: 1.5,
                                        border: '1px solid #e0e0e0',
                                        borderRadius: '4px',
                                        backgroundColor: targetValue === 0 ? '#eef8f0' : '#f9f9f9',
                                        display: 'flex',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <Typography variant="body2" color="primary" fontWeight="bold" noWrap>
                                        {getCalculationText()}
                                      </Typography>
                                    </Box>
                                    {targetValue === 0 && (
                                      <div style={{ fontSize: '12px', color: '#8a8f98', marginTop: '4px' }}>
                                        Target is 0, so the staff does not need to achieve any target. The incentive is
                                        credited from the first sale.
                                      </div>
                                    )}
                            </Grid>
                          </>
                        )}
                      </Grid>
              </CardContent>
            </Card>
          </DialogContent>
          <DialogActions sx={{ p: 1.5, gap: 1 }}>
            <Button
              variant="outlined"
              onClick={handleCloseDialogue}
              sx={{ minWidth: '80px', fontSize: '0.875rem' }}
              size="small"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleUpdateStaffData}
              sx={{
                background: '#6174DD',
                minWidth: '80px',
                fontSize: '0.875rem'
              }}
              disabled={loading}
              size="small"
            >
              {loading ? <ShowLoader size={20} /> : 'Update'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Status Confirmation Dialog */}
        <Dialog open={openConfirmDialogue} onClose={handleCloseStatusDialogue} maxWidth="xs" fullWidth>
          <DialogContent>
            <Typography sx={{ fontSize: '0.9rem' }}>
              Are you sure you want to {accountStatus ? 'deactivate' : 'activate'} this account?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseStatusDialogue} size="small">Cancel</Button>
            <Button onClick={handleConfirmStatus} color="primary" size="small">
              Confirm
            </Button>
          </DialogActions>
        </Dialog>

        {/* Delete Dialog */}
        <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)} maxWidth="xs" fullWidth>
          <DialogContent>
            <Typography sx={{ fontSize: '0.9rem' }}>Are you sure you want to delete this staff?</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenDeleteDialog(false)} size="small">Cancel</Button>
            <Button onClick={confirmDelete} color="error" size="small">
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
};

export default FieldData;
